/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconChevronDown from '@telus-uds/palette-koodo/build/rn/icons/ChevronDown'
import PaletteIconChevronUp from '@telus-uds/palette-koodo/build/rn/icons/ChevronUp'
const theme = {
  appearances: {
    expanded: {
      description: 'Applies when an ExpandCollapse panel is open and the content inside is visible',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { expanded: true },
      tokens: { icon: PaletteIconChevronUp }
    }
  ],
  tokens: {
    collapseDuration: 250,
    contentPaddingBottom: 0,
    contentPaddingLeft: 0,
    contentPaddingRight: 0,
    contentPaddingTop: 0,
    expandDuration: 300,
    icon: PaletteIconChevronDown,
    iconColor: '#000000',
    iconGap: 8,
    iconPosition: 'right',
    iconSize: 16,
    justifyContent: 'space-between',
    verticalAlign: 'middle'
  }
}
export default theme
